import Relay from 'react-relay';
import PersonDetail from './PersonDetail';
import PersonDetailStickyHeader from './StickyHeader';
import PersonDetailBio from './Bio';
import PersonDetailObjectList from './ObjectList';
import settings from '../../../../config/settings';
import {getCurrentLanguage} from '../../../localData';

export default Relay.createContainer(PersonDetail, {
    initialVariables: {
        id: 65985,
        lang: getCurrentLanguage() || settings.defaultLanguage,
    },
    fragments: {
        store: () => Relay.QL`
            fragment on Store {
                myCollectionDesignersIds,
                myCollectionProducersIds,
                person(id: $id, lang: $lang) {
                    id,
                    PerNameSortedTxt,
                    PerNameTxt,
                    PerTypeVoc,
                    PerDatingTxt,
                    PerStandardImage,
                    PerThumbnail,
                    PerMarkdown,
                    PerObjectsCount,
                    PerBirthPlaceCity,
                    PerBirthPlaceCountry,
                    ${PersonDetailStickyHeader.getFragment('person')},
                    ${PersonDetailBio.getFragment('person')},
                    ${PersonDetailObjectList.getFragment('person')},
                }
            }
        `,
    },
});



// WEBPACK FOOTER //
// ./app/components/Person/Detail/index.js